import { Box, Stack, Text } from '@chakra-ui/react';
import { LandingPageLayout } from 'Layouts/LandingPageLayout';
import React from 'react';
import { IChildren } from 'Types/Interface/Sanity';
import { useTermsOfServiceUserLocalization } from 'Utils/localizationHooks';
import { TermsOfServiceJumbotronSection } from './TermsOfServiceBrands';


export const TermsOfServiceUser = () => {
	const { localization: termsLocalization } = useTermsOfServiceUserLocalization();

	return(
		<LandingPageLayout JumbotronSection={<TermsOfServiceJumbotronSection />} >
			<Stack spacing={6} pt={12}>
						
				{  termsLocalization?.termsOfServiceUser?.map((term) => (
					<Box key={term._key}>
						<Text  fontSize="14px" fontWeight={500} color="#121B26">
							{term.children.map((child:IChildren) =>
								child.marks.includes('strong') ? (
								<strong key={child._key}>{child.text}</strong>
								) : (
								<span key={child._key}>{child.text}</span>
								)
							)}
						</Text>
					</Box>
				)) }
			</Stack>
		</LandingPageLayout>
	);
};